// 管理費関連のタイプとAPIフィールドのマッピング

export type ManagementCostType =
  | "賃貸管理費"
  | "建物管理費"
  | "修繕積立金"
  | "通信費"
  | "その他経費"
  | "その他の経費"
  | "固定資産税・都市計画税"
  | "消耗品費"
  | "設備修繕、大規模修繕費用"
  | "その他一過性の支出";

// 管理費関連のコストタイプをAPIフィールドにマッピング
export const getManagementCostTypeKey = (costType: ManagementCostType): string => {
  const costTypeKeyMap: Record<ManagementCostType, string> = {
    賃貸管理費: "management_cost",
    建物管理費: "building_management_cost",
    修繕積立金: "repair_fund_cost",
    通信費: "communication_cost",
    その他経費: "misc_cost",
    その他の経費: "misc_cost",
    "固定資産税・都市計画税": "property_tax",
    消耗品費: "supplies_cost",
    "設備修繕、大規模修繕費用": "large_scale_repair_fund_cost",
    その他一過性の支出: "misc_onetime_cost",
  };
  return costTypeKeyMap[costType];
};
